import { Lugar } from './../../../servicios/lugares.service';
import { Area, PersonaAutoriza } from './../../../servicios/areas.service';
import { AreasService } from 'src/app/servicios/areas.service';
import { ToastService } from './../../../servicios/toast.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { TIPOS_VISITAS, VisitantesService } from './../../../servicios/visitantes.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderInfoService } from './../../../servicios/header-info.service';
import { Component, Input, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import moment from 'moment';
import { MatLegacyCheckboxChange as MatCheckboxChange } from '@angular/material/legacy-checkbox';

@Component({
  selector: 'app-detalle-visitante',
  templateUrl: './detalle-visitante.component.html',
  styleUrls: ['./detalle-visitante.component.scss']
})
export class DetalleVisitanteComponent implements OnInit {

  // Exponer TIPOS_VISITAS para usar en el template
  TIPOS_VISITAS = TIPOS_VISITAS;

  fechaSalidaIndefinida: boolean = false;
  editable: boolean;
  cargando: boolean = false;

  public seleccionarFechaHoraLlegada: boolean = false;
  public seleccionarFechaHoraSalida: boolean = false;

  fechaHoraLlegada = moment();
  fechaHoraSalida = moment();

  public idVisitante: string;
  public visitanteInfoForm: UntypedFormGroup;
  public areas: Area[];
  public apartamentos: Lugar[];
  public miembros: PersonaAutoriza[];
  public selfieUrl: string = '';
  public statusName: string = '';
  public selfieError: boolean = false;
  public typeUser: string = ''; // 'V', 'C', o 'P'
  
  // Checks del protocolo de seguridad
  public checkRostro: boolean = false;
  public checkDocumento: boolean = false;
  public checkVehiculo: boolean = false;
  
  public tiposDeDocumentos = [
    "Cédula",
    "NIT",
    "Cédula Extranjería",
    "Tarjeta Identidad",
    "Pasaporte",
    "Registro Civil",
  ];

  public vehiculos = [
    "Carro",
    "Moto",
    "Bicicleta"
  ];

  constructor(
    private headerInfoService: HeaderInfoService,
    private route: ActivatedRoute,
    private visitantesService: VisitantesService,
    private areasService: AreasService,
    private toastService: ToastService,
    private readonly location: Location,
    private router: Router,
  ) { }
  
  ngOnDestroy() {
    this.headerInfoService.dejarSoloBotonMenu(false);  
  }

  ngOnInit(): void {
    this.headerInfoService.dejarSoloBotonMenu(true);
    this.headerInfoService.cambiarTituloTarjeta("¡INFORMACIÓN VISITANTE!");
    this.headerInfoService.cambiarTextoTarjeta("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo.");

    if (this.location.path().includes("visitantes/nuevo")) {
      this.editable = true;
      this.visitanteInfoForm = new UntypedFormGroup({
        place_id: new UntypedFormControl(null, [Validators.required]),
        name: new UntypedFormControl(null, [Validators.required]),
        type_document: new UntypedFormControl(null, [Validators.required]),
        number_document: new UntypedFormControl(null, [Validators.required]),
        indicative: new UntypedFormControl("+57", [Validators.required]),
        phone: new UntypedFormControl(null, [Validators.required]),
        user_id: new UntypedFormControl(null, [Validators.required]),
        date_checkin: new UntypedFormControl(null),
        hour_checkin: new UntypedFormControl(null),
        hour_checkout: new UntypedFormControl(null),
        type_vehicle: new UntypedFormControl(null),
        note: new UntypedFormControl(null),
        area: new UntypedFormControl(null, [Validators.required]),
        plate_vehicle: new UntypedFormControl(null),
        mark: new UntypedFormControl(null),
      });
      this.actualizarFechaHoraLlegada(moment());
      this.actualizarFechaHoraSalida(moment().add(3, 'hours'));

      this.areasService.traerAreasUnidad().subscribe(res => {
        this.areas = res;

      }, err => {
        this.toastService.mostrarToast(err.error.message);
      });

      this.esucharCambioArea();
      this.esucharCambioApartamento();
      
    } else {
      this.idVisitante = this.route.snapshot.paramMap.get("id");
  
      this.visitantesService.traerVisitante(this.idVisitante).subscribe(res => {
        const infoVisitante = res.data.data_visitante;
  
        const dateCheckIn = moment(infoVisitante.date_checkin);
        const hhmmssCheckIn = infoVisitante.hour_checkin.split(":");
        const dateCheckOut = moment(infoVisitante.date_checkin);
        const hhmmssCheckOut = infoVisitante.hour_checkout.split(":");
        
        dateCheckIn.set("hour", parseInt(hhmmssCheckIn[0]));
        dateCheckIn.set("minute", parseInt(hhmmssCheckIn[1]));
  
        dateCheckOut.set("hour", parseInt(hhmmssCheckOut[0]));
        dateCheckOut.set("minute", parseInt(hhmmssCheckOut[1]));

        // Store selfie URL, status name, and type_user
        this.selfieUrl = (infoVisitante as any).selfie || '';
        this.statusName = (infoVisitante as any).status_name || '';
        this.typeUser = infoVisitante.type_user || 'V'; // Default to 'V' if not provided
        this.selfieError = false; // Reset error when loading new visitor
        
        // Reset checks when loading new visitor
        this.checkRostro = false;
        this.checkDocumento = false;
        this.checkVehiculo = false;
  
        this.visitanteInfoForm = new UntypedFormGroup({
          area: new UntypedFormControl(infoVisitante.area_name, [Validators.required]),
          apartamento: new UntypedFormControl(infoVisitante.site_name, [Validators.required]),
          name: new UntypedFormControl(infoVisitante.name, [Validators.required]),
          type_document: new UntypedFormControl(infoVisitante.type_document, [Validators.required]),
          number_document: new UntypedFormControl(infoVisitante.number_document, [Validators.required]),
          indicative: new UntypedFormControl(infoVisitante.indicative, [Validators.required]),
          phone: new UntypedFormControl(infoVisitante.phone, [Validators.required]),
          hour_checkin: new UntypedFormControl(dateCheckIn.format("DD-MM-YYYY hh:mm a"), [Validators.required]),
          hour_checkout: new UntypedFormControl(dateCheckOut.format("DD-MM-YYYY hh:mm a"), [Validators.required]),
          type_vehicle: new UntypedFormControl(infoVisitante.type_vehicle || "-", [Validators.required]),
          plate_vehicle: new UntypedFormControl(infoVisitante.plate_vehicle || "-", [Validators.required]),
          brand_vehicle: new UntypedFormControl(infoVisitante.brand_vehicle || "-", [Validators.required]),
          note: new UntypedFormControl(infoVisitante.note || "-", [Validators.required]),
          aut_name: new UntypedFormControl(infoVisitante.aut_name, [Validators.required]),
          status: new UntypedFormControl(infoVisitante.status),
        });
      }, err => {
        this.toastService.mostrarToast(err.error.message);
      })     
    }
  }

  toggleMostrarCalendarioLlegada() {
    this.seleccionarFechaHoraLlegada = !this.seleccionarFechaHoraLlegada;
    this.seleccionarFechaHoraSalida = false;
  }

  toggleMostrarCalendarioSalida() {
    this.seleccionarFechaHoraSalida = !this.seleccionarFechaHoraSalida;
    this.seleccionarFechaHoraLlegada = false;
  }

  actualizarFechaHoraLlegada(fecha) {
    this.fechaHoraLlegada = fecha;
    this.fechaHoraSalida.set({
      year: this.fechaHoraLlegada.year(),
      month: this.fechaHoraLlegada.month(),
      date: this.fechaHoraLlegada.date()
    });
    this.visitanteInfoForm.get("date_checkin").setValue(this.fechaHoraLlegada.format("YYYY-MM-DD"));
    this.visitanteInfoForm.get("hour_checkin").setValue(this.fechaHoraLlegada.format("HH:mm:ss"));
  }

  actualizarFechaHoraSalida(fecha) {
    this.fechaHoraSalida = fecha;
    this.fechaHoraLlegada.set({
      year: this.fechaHoraSalida.year(),
      month: this.fechaHoraSalida.month(),
      date: this.fechaHoraSalida.date()
    });
    this.visitanteInfoForm.get("date_checkin").setValue(this.fechaHoraSalida.format("YYYY-MM-DD"));
    this.visitanteInfoForm.get("hour_checkout").setValue(this.fechaHoraSalida.format("HH:mm:ss"));
  }

  crearVisitante() {
    if(!this.visitanteInfoForm.valid) {
      this.toastService.mostrarToast("Por favor complete todos los campos");
      this.visitanteInfoForm.markAllAsTouched();
    } else {
      this.cargando = true;
      this.visitantesService.crearVisitante({
        ...this.visitanteInfoForm.value,
        hour_checkout: this.fechaSalidaIndefinida ? null : this.visitanteInfoForm.get("hour_checkout").value
      }).subscribe(res => {
        this.cargando = false;
        console.log(res);
        this.toastService.mostrarToast("Se ha guardado el visitante exitosamente");
        this.router.navigate([""]);
      }, err => {
        this.cargando = false;
        this.toastService.mostrarToast(err.error.message);
      });
    }
  }

  esucharCambioArea() {
    this.visitanteInfoForm.get("area").valueChanges.subscribe((areaElegida: Area) => {
      this.areasService.traerApartamentosArea(areaElegida.id).subscribe(
        res => this.apartamentos = res,
        err => this.toastService.mostrarToast(err.error.message)
      );
    }, err => {
      this.toastService.mostrarToast(err.error.message);
    });
  }

  esucharCambioApartamento() {
    this.visitanteInfoForm.get("place_id").valueChanges.subscribe((idApartamento: number) => {
      this.areasService.traerPersonasAutorizanVisitasPorApartamento(this.visitanteInfoForm.get("area").value.id, idApartamento).subscribe(
        res => this.miembros = res,
        err => console.log(err)
      );
    }, err => {
      this.toastService.mostrarToast(err.error.message);
    });
  }

  cambiarFechaSalidaIndefinida(arg: MatCheckboxChange, obj:any) {
    this.fechaSalidaIndefinida = arg.checked;
  }

  volverAVisitantes() {
    this.router.navigate(["visitantes"]);
  }

  get area() {
    return this.visitanteInfoForm.get("area");
  }

  get place_id() {
    return this.visitanteInfoForm.get("place_id");
  }

  get user_id() {
    return this.visitanteInfoForm.get("user_id");
  }

  get name() {
    return this.visitanteInfoForm.get("name");
  }

  get type_document() {
    return this.visitanteInfoForm.get("type_document");
  }

  get number_document() {
    return this.visitanteInfoForm.get("number_document");
  }

  get indicative() {
    return this.visitanteInfoForm.get("indicative");
  }

  get phone() {
    return this.visitanteInfoForm.get("phone");
  }

  get estaActivo() {
    const statusActivo = this.visitanteInfoForm.get("status")?.value === TIPOS_VISITAS.PENDIENTE
    const checksCompletos = this.validarChecksCompletos();
    return statusActivo && checksCompletos;
  }

  validarChecksCompletos(): boolean {
    const tieneVehiculo = this.visitanteInfoForm.get('type_vehicle')?.value && 
                         this.visitanteInfoForm.get('type_vehicle')?.value !== '0' && 
                         this.visitanteInfoForm.get('type_vehicle')?.value !== '-';
    
    // Si tiene vehículo, se requieren los 3 checks, si no, solo los 2 primeros
    if (tieneVehiculo) {
      return this.checkRostro && this.checkDocumento && this.checkVehiculo;
    } else {
      return this.checkRostro && this.checkDocumento;
    }
  }

  toggleCheckRostro() {
    this.checkRostro = !this.checkRostro;
  }

  toggleCheckDocumento() {
    this.checkDocumento = !this.checkDocumento;
  }

  toggleCheckVehiculo() {
    this.checkVehiculo = !this.checkVehiculo;
  }

  public registrarVisitante() {
    this.visitantesService.registrarVisitante(this.idVisitante).subscribe(res => {
      this.visitanteInfoForm.get("status").setValue(0)
      this.toastService.mostrarToast("Visitante registrado satisfactoriamente");
    }, err => {
      this.toastService.mostrarToast(err.error.message);
    });
  }

  getTipoTerceroNombre(codigo: string): string {
    const tipos: { [key: string]: { type: string; description: string } } = {
      'V': { type: 'Visitante', description: 'Reuniones y visitas comerciales' },
      'C': { type: 'Contratista', description: 'Obras, mantenimiento y técnicos' },
      'P': { type: 'Proveedor', description: 'Logística, entregas y suministros' }
    };
    
    if (!codigo || !tipos[codigo]) {
      return 'Visitante';
    }
    
    return tipos[codigo].type;
  }

  getTipoTerceroDescripcion(codigo: string): string {
    const tipos: { [key: string]: { type: string; description: string } } = {
      'V': { type: 'Visitante', description: 'Reuniones y visitas comerciales' },
      'C': { type: 'Contratista', description: 'Obras, mantenimiento y técnicos' },
      'P': { type: 'Proveedor', description: 'Logística, entregas y suministros' }
    };
    
    if (!codigo || !tipos[codigo]) {
      return '';
    }
    
    return tipos[codigo].description;
  }
}